var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VSelect',_vm._g({attrs:{"outlined":"","value":_vm.value,"items":_vm.getItems,"rules":_vm.rules,"loading":_vm.loading,"prepend-inner-icon":"mdi-package-variant","item-text":"name","item-value":"id","label":"Package Type","return-object":"","clearable":""}},_vm.inputListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }